import "./styles.less";
import { useEffect, useState } from "react";
import { getTurboEndTime, formatRemaining, TurboProduct } from "./hook";

// INF-106 — chip «↑ EN EL TOP» + countdown del Asciende en el listado (señales v2, por flag y por país — ver INF-1351).
// El tick por segundo vive acá (hoja, sin dynamic imports): solo re-renderiza este chip,
// nunca la ListingCard entera. A cero se oculta (render null).
// INF-196 — interruptor ÚNICO del countdown para todo el sitio (SERP + ficha): en `false`
// ningún chip lo monta y queda solo la píldora blanca. Se cambia acá, en un solo lugar.
// La prop `showClock` de abajo sólo existe para apagarlo en una pantalla puntual sin tocar
// el resto; mientras nadie la pase, manda esta constante.
// INF-221 — con el interruptor en `true` el countdown se MONTA pero arranca oculto detrás de
// la píldora: sólo asoma al hacer hover (el deslizamiento y la transición viven en el .less).
// Sigue siendo `true` porque el hover necesita el nodo en el DOM; ponerlo en `false` apaga la
// función completa, no sólo su visibilidad.
const ASCIENDE_CLOCK_ENABLED = true;

// El tick sigue corriendo igual aunque el countdown no se muestre: es lo que apaga el chip
// entero al llegar a cero.
export const AsciendeChip = ({
	turbo,
	showClock = ASCIENDE_CLOCK_ENABLED,
}: {
	turbo?: TurboProduct;
	showClock?: boolean;
}) => {
	const [label, setLabel] = useState<string>("");

	useEffect(() => {
		const end = getTurboEndTime(turbo);
		if (!end) {
			setLabel("");
			return;
		}
		let intervalId: any = null;
		const tick = () => {
			const remaining = end - Date.now();
			if (remaining <= 0) {
				setLabel("");
				if (intervalId) clearInterval(intervalId);
				return;
			}
			setLabel(formatRemaining(remaining));
		};
		tick();
		intervalId = setInterval(tick, 1000);
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [turbo && turbo.end_date, turbo && turbo.start_hour]);

	if (!label) return null;

	return (
		<span className={`asciende-chip${showClock ? " asciende-chip--with-clock" : ""}`}>
			<svg
				className="asciende-chip__arrow"
				viewBox="0 0 16 19.4783"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M3.33333 9.73913L8 4.05797L12.6667 9.73913"
					stroke="#243E88"
					strokeWidth={2}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 15.4203V4.05797"
					stroke="#243E88"
					strokeWidth={2}
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
			<span className="asciende-chip__label">En el top</span>
			{/* El countdown es un adorno visual: el significado lo carga «En el top». Va
			    `aria-hidden` porque `opacity: 0` NO lo saca del árbol de accesibilidad, y un
			    lector leería los dígitos —que cambian cada segundo— aunque no se vean. */}
			{showClock && (
				<span className="asciende-chip__clock" aria-hidden>
					{label}
				</span>
			)}
		</span>
	);
};
